import { render, staticRenderFns } from "./NoticeOfCrossAppealRspToAppealPg.vue?vue&type=template&id=14271997&scoped=true"
import script from "./NoticeOfCrossAppealRspToAppealPg.vue?vue&type=script&lang=ts"
export * from "./NoticeOfCrossAppealRspToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14271997",
  null
  
)

export default component.exports